
<div fxLayout="column">
  <mat-tab-group (selectedTabChange)="socureTabChange($event)" [selectedIndex]="activeTabIndex">
    <div *ngFor="let applicantRequest of applicantRequests;">
      <mat-tab label="{{applicantRequest.firstName}} {{applicantRequest.lastName}}">
        <div class="loading-alloy" [ngClass]="{ 'visible': alloyFrameIsNotLoadedMap.get(applicantRequest.applicantId!), 'invisible': !alloyFrameIsNotLoadedMap.get(applicantRequest.applicantId!)}" fxLayout="column" fxLayoutAlign="center center" class="processing-card card">
          <div id="processing-logo-area">&nbsp;</div>

          <div class="detail-header">Your application is currently being reviewed.</div>
          <div class="detail-header">Please do not refresh this page.</div>
          <br/>
          <mat-spinner diameter="20" strokeWidth="2"></mat-spinner>
        </div>
      </mat-tab>
    </div>
  </mat-tab-group>

  <div *ngIf="journeyApplicationToken.length > 0">
    <div *ngFor="let applicantRequest of applicantRequests; let indexOfElements = index;">
      <div [hidden]="indexOfElements != activeTabIndex">
        <iframe [ngClass]="{ 'visible': !alloyFrameIsNotLoadedMap.get(applicantRequest.applicantId!), 'invisible': alloyFrameIsNotLoadedMap.get(applicantRequest.applicantId!)}" width="100%" height="800" scrolling="no" [src]="getAlloySdkUrl(indexOfElements) | safe" (load)="onAlloyFrameLoaded(applicantRequest.applicantId!)" [frameBorder]="0"></iframe>
      </div>
    </div>
  </div>
</div>
